// extracted by mini-css-extract-plugin
export default {"counter":"MoneyCounter_counter__4wAfO"};